var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.10394 3.14996C7.47078 2.40679 8.53052 2.4068 8.89736 3.14996L9.82821 5.03576C9.97375 5.33061 10.2549 5.53506 10.5803 5.58262L12.6635 5.88712C13.4834 6.00696 13.8102 7.0148 13.2166 7.59296L11.7108 9.05968C11.4749 9.28942 11.3672 9.62055 11.4229 9.94508L11.7781 12.016C11.9182 12.8329 11.0606 13.4559 10.327 13.0701L8.4661 12.0914C8.17472 11.9382 7.82658 11.9382 7.5352 12.0914L5.67428 13.0701C4.94065 13.4559 4.0831 12.8329 4.22322 12.016L4.5784 9.94508C4.63407 9.62055 4.5264 9.28942 4.29053 9.05968L2.78466 7.59296C2.19107 7.0148 2.51785 6.00696 3.33777 5.88712L5.42102 5.58262C5.74637 5.53506 6.02756 5.33061 6.1731 5.03576L7.10394 3.14996Z",
    fill: "#FF5917"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar1);
export default __webpack_public_path__ + "static/media/star1.4ee47237b4a760ea88f36571fceccc81.svg";
export { ForwardRef as ReactComponent };